<app-navbar></app-navbar>
    <div class="pro-lg-ban position-relative" [ngStyle]="{'background-image': 'url(' + product()?.banner + ')'}">
        <div class="pro-lg-ban-f position-absolute w-100"></div>
        <div class="container">
            <div class="col-lg-12">
                <div class="pro-md-ban mb-5"></div>
                <div class="pro-thumb position-absolute bg-white rounded-5">
                    <img [lazyLoad]="product()?.thumbnail!" [defaultImage]="defaultImage" [alt]="product()?.item" class="object-fit-cover w-100" animate.enter="fadein" animate.leave="fadeout">
                </div>
            </div>
        </div>
    </div>
    <div class="container pt-3 inter">
        <div class="row">
            <div class="col-lg-8">
                <div class="product-item pt-4 ps-4 pe-4 pb-4 rounded-3">
                     <div class="inter fs-7 mb-5 fw-medium breadcrumb">
                        <a [routerLink]="['/']" class="text-decoration-none" title="Home">
                            <strong>Home</strong>
                        </a>
                        <img src="assets/icons/arrow_right.svg" alt="Breadcrumb"> 
                        <a [routerLink]="['/products']" class="text-decoration-none" title="Products">
                            <strong>Products</strong>
                        </a>
                        <img src="assets/icons/arrow_right.svg" alt="Breadcrumb">
                        <span class="text-muted" [title]="product()?.item!" [title]="product()?.item!">{{product()?.item! | truncate: 70}}</span>
                    </div>
                    <div class="fs-7 text-muted product-tag">
                        @for (obj of keywords(); track obj.slug) {
                            <span class="border rounded-5 py-2 px-3 me-3 mb-3">{{obj.keyword}}</span>
                        }
                    </div>
                    <h1 class="fw-semibold mb-3 mt-4">{{product()?.item}}</h1>
                    <p class="text-muted lh-lg">{{product()?.description}}</p>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="product-buy p-4 rounded-3">
                    <h5>Where can the product be purchased</h5>
                    <p class="inter fs-6 text-muted">Available in all leading online e-commerce platform</p>
                    <div class="container p-0">
                        <div class="row">
                            <div class="col-lg-6">
                                <a href="https://shopee.ph/bewellnutraceuticalscorp">
                                    <div class="pro-ecom" [ngStyle]="{'background-image': 'url(/assets/platforms/shopee.jpg)'}"></div>
                                </a>
                            </div>
                            <div class="col-lg-6">
                                 <a href="https://www.lazada.com.ph/bewell/">
                                   <div class="pro-ecom" [ngStyle]="{'background-image': 'url(/assets/platforms/lazada.jpg)'}"></div>
                                </a>
                            </div>
                            <div class="col-lg-6">
                                <a href="https://www.tiktok.com/@bewell_shop?lang=en">
                                   <div class="pro-ecom" [ngStyle]="{'background-image': 'url(/assets/platforms/tiktok-shop.jpg)'}"></div>
                                </a>
                            </div>
                            <div class="col-lg-6">
                                <a href="http://shop.bewell.com.ph">
                                   <div class="pro-ecom" [ngStyle]="{'background-image': 'url(/assets/platforms/bewell-express.jpg)'}"></div>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="d-grid">
                        <button type="button" class="btn btn-block btn-dark rounded-2 fs-7 product-buy-btn" (click)="toBewellShop()">Order and Buy Now</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row inter mt-3">
            @if(hasBenefits()){
                <div class="col-lg-12">
                    <h3 class="fw-semibold mb-4 display-6">What are the benefits?</h3>
                </div>
            }
            @if(!isLoading()){
                @for (obj of benefits(); track obj.id) {
                    <div class="col-lg-3">
                        <div class="pro-ben">
                            <img src="assets/icons/star-gray.svg" alt="">
                            <p class="mt-2">{{obj.benefit}}</p>
                        </div>
                    </div>
                }
            }
        </div>
    </div>
    <app-what-our-customers-say></app-what-our-customers-say>
    <div class="container p-0 mt-5">
        <div class="col-lg-12">
            <h3 class="fw-semibold display-6">Where i can buy it</h3>
            <p class="text-muted inter">Available in all leading drugstores nationwide</p>
        </div>
        <div class="row">
            <div class="col-lg-3">
                <img src="assets/drugstores/mercury.webp" alt="Mercury Drug" class="img-fluid border-light border rounded-2" title="">
            </div>
            <div class="col-lg-3">
                <img src="assets/drugstores/watsons.webp" alt="Watsons" class="img-fluid border-light border rounded-2">
            </div>
            <div class="col-lg-3">
                <img src="assets/drugstores/south-star.webp" alt="South Start" class="img-fluid border-light border rounded-2">
            </div>
            <div class="col-lg-3">
                <img src="assets/drugstores/rose-pharmacy.webp" alt="Rose Pharmacy" class="img-fluid border-light border rounded-2">
            </div>
        </div>
    </div>
    <div class="container mb-5 mt-5">
        <div class="row inter">
            <div class="col-lg-12">
                @if(faqs().length! > 0){
                    <h3 class="fw-semibold mb-5 mt-5 display-6">Frequently Asked Questions?</h3>
                }
                @if(isLoading()){
                    <ngx-skeleton-loader 
                    count="6" 
                    appearance="line" 
                    [theme]="{ 
                        'height': '55px', 
                        'margin-bottom': '30px', 
                        'width': '100%', 
                        'border-radius': '3px' 
                    }"></ngx-skeleton-loader>
                }
                <div class="accordion">
                    @for (obj of faqs(); track obj.id; let isFirst = $first) {
                        <div class="accordion-item">
                            <h2 class="accordion-header m-0" [id]="'heading-' + obj.id">
                                <button class="accordion-button btn fw-semibold text-dark" 
                                        [class.collapsed]="!isFirst"
                                        type="button" 
                                        data-bs-toggle="collapse" 
                                        [attr.data-bs-target]="'#collapse-' + obj.id" 
                                        [attr.aria-expanded]="isFirst" 
                                        [attr.aria-controls]="'collapse-' + obj.id">
                                    {{obj.question}}
                                </button>
                            </h2>
                            <div [id]="'collapse-' + obj.id" 
                                class="accordion-collapse collapse" 
                                [class.show]="isFirst"
                                [attr.aria-labelledby]="'heading-' + obj.id"
                                data-bs-parent="#faqAccordion">
                                <div class="accordion-body text-muted">
                                    <p>{{obj.answer}}</p>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
<app-footer></app-footer>